/**
 * BeeBuilt Social Embed
 * Usage in blog post body (via Show HTML editor):
 * <div class="bee-social-embed" data-embed="youtube" data-url="https://youtube.com/watch?v=XXXX"></div>
 * <div class="bee-social-embed" data-embed="instagram" data-url="https://instagram.com/p/XXXX"></div>
 * <div class="bee-social-embed" data-embed="tiktok" data-url="https://tiktok.com/@user/video/XXXX"></div>
 * <div class="bee-social-embed" data-embed="x" data-url="https://x.com/user/status/XXXX"></div>
 * <div class="bee-social-embed" data-embed="pinterest" data-url="https://pinterest.com/pin/XXXX"></div>
 * <div class="bee-social-embed" data-embed="facebook-post" data-url="https://facebook.com/user/posts/XXXX"></div>
 * <div class="bee-social-embed" data-embed="facebook-video" data-url="https://facebook.com/user/videos/XXXX"></div>
 */
(function () {
  'use strict';

  var SCRIPT_LOADED = {};

  function loadScript(src, cb) {
    if (SCRIPT_LOADED[src]) {
      if (window[SCRIPT_LOADED[src]]) cb();
      return;
    }
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    s.onload = cb;
    document.body.appendChild(s);
    SCRIPT_LOADED[src] = true;
  }

  function getYouTubeId(url) {
    var m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([a-zA-Z0-9_-]{6,})/);
    return m ? m[1] : null;
  }

  function buildYouTube(el, url) {
    var id = getYouTubeId(url);
    if (!id) return showError(el, 'Invalid YouTube URL');
    var wrap = document.createElement('div');
    wrap.className = 'bee-embed-frame-wrap';
    wrap.innerHTML = '<iframe src="https://www.youtube.com/embed/' + id +
      '" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
    el.appendChild(wrap);
  }

  function buildInstagram(el, url) {
    var clean = url.split('?')[0];
    el.innerHTML = '<blockquote class="instagram-media" data-instgrm-permalink="' + clean +
      '" data-instgrm-version="14" style="margin:0 auto;"></blockquote>';
    loadScript('https://www.instagram.com/embed.js', function () {
      if (window.instgrm) window.instgrm.Embeds.process();
    });
  }

  function buildTikTok(el, url) {
    el.innerHTML = '<blockquote class="tiktok-embed" cite="' + url +
      '" style="max-width:540px;min-width:325px;"><section></section></blockquote>';
    loadScript('https://www.tiktok.com/embed.js', function () {
      if (window.TikTok && window.TikTok.embed) window.TikTok.embed.lib.render(el);
    });
  }

  function buildX(el, url) {
    el.innerHTML = '<blockquote class="twitter-tweet"><a href="' + url + '"></a></blockquote>';
    loadScript('https://platform.twitter.com/widgets.js', function () {
      if (window.twttr && window.twttr.widgets) window.twttr.widgets.load(el);
    });
  }

  function buildPinterest(el, url) {
    el.innerHTML = '<a data-pin-do="embedPin" href="' + url + '"></a>';
    loadScript('https://assets.pinterest.com/js/pinit.js', function () {
      if (window.PinUtils) window.PinUtils.build();
    });
  }

  function buildFacebookPost(el, url) {
    el.innerHTML = '<div class="fb-post" data-href="' + url + '" data-width="500"></div>';
    loadFacebookSDK(el);
  }

  function buildFacebookVideo(el, url) {
    var wrap = document.createElement('div');
    wrap.className = 'bee-embed-frame-wrap';
    wrap.innerHTML = '<iframe class="bee-embed-fb-post" src="https://www.facebook.com/plugins/video.php?href=' +
      encodeURIComponent(url) + '&show_text=false" loading="lazy" allowfullscreen></iframe>';
    el.appendChild(wrap);
  }

  function loadFacebookSDK(el) {
    if (window.FB) {
      window.FB.XFBML.parse(el);
      return;
    }
    if (document.getElementById('fb-root')) {
      // SDK already loading, poll for it
      var tries = 0;
      var poll = setInterval(function () {
        tries++;
        if (window.FB) {
          window.FB.XFBML.parse(el);
          clearInterval(poll);
        } else if (tries > 20) {
          clearInterval(poll);
        }
      }, 250);
      return;
    }
    var root = document.createElement('div');
    root.id = 'fb-root';
    document.body.insertBefore(root, document.body.firstChild);
    var s = document.createElement('script');
    s.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v19.0';
    s.async = true;
    s.defer = true;
    document.body.appendChild(s);
  }

  function showError(el, msg) {
    el.innerHTML = '<div class="bee-embed-placeholder">' + msg + '</div>';
  }

  function buildEmbed(el) {
    var type = el.getAttribute('data-embed');
    var url = el.getAttribute('data-url');
    if (!url) return showError(el, 'Missing embed URL');

    switch (type) {
      case 'youtube': return buildYouTube(el, url);
      case 'instagram': return buildInstagram(el, url);
      case 'tiktok': return buildTikTok(el, url);
      case 'x':
      case 'twitter': return buildX(el, url);
      case 'pinterest': return buildPinterest(el, url);
      case 'facebook-post': return buildFacebookPost(el, url);
      case 'facebook-video': return buildFacebookVideo(el, url);
      default: return showError(el, 'Unknown embed type: ' + type);
    }
  }

  function init() {
    var nodes = document.querySelectorAll('.bee-social-embed[data-embed]');
    if (!nodes.length) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            buildEmbed(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px 0px' });

      nodes.forEach(function (el) { observer.observe(el); });
    } else {
      nodes.forEach(buildEmbed);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();